<ntv-modal
    [isVisible]="isVisible()"
    (modalClose)="onClose()"
    [closeOnBackdrop]="false"
    size="medium"
    modalHeight="auto"
    [showHeader]="false"
    [showFooter]="false">
    <div class="generate-modal">
        <div class="generate-modal__header">
            <div>
                <h2 class="generate-modal__title">Generate License</h2>
                <p class="generate-modal__subtitle">
                    Choose a dealer and set number of license to generate.
                </p>
            </div>
            <button class="generate-modal__close" (click)="onClose()">&#x2715;</button>
        </div>

        <div class="generate-modal__body">
            <div class="generate-modal__field">
                <label class="generate-modal__label">Select Dealer Business Name</label>
                <app-autocomplete
                    [options]="dealerOptions()"
                    [config]="autocompleteConfig"
                    [loading]="isLoadingDealers()"
                    [loadingMore]="isLoadingMore()"
                    [(selectedOptions)]="selectedDealerOptions"
                    (onSelect)="onDealerChange($event)"
                    (onScrollEnd)="onScrollEnd()"
                    (onSearch)="onSearch($event)" />
            </div>

            <div class="generate-modal__field">
                <label class="generate-modal__label">Number of Licenses</label>
                <ntv-input
                    type="number"
                    placeholder="Number of Licenses"
                    [ngModel]="form().count"
                    (ngModelChange)="onCountChange($event)" />
            </div>
        </div>

        <div class="generate-modal__footer">
            <ntv-button
                color="custom"
                customColor="#8DCB2C"
                size="xl"
                rounded="md"
                [disabled]="!isFormValid || isGenerating()"
                [loading]="isGenerating()"
                (buttonClick)="onGenerate()">
                <div class="generate-modal__btn-content text-white">
                    <span>Generate License</span>
                    <svg width="14" height="14">
                        <use href="assets/icons/icons-sprite.svg#licenses"></use>
                    </svg>
                </div>
            </ntv-button>
        </div>
    </div>
</ntv-modal>
